import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import VehicleCard from './VehicleCard';
import './VehicleShowcase.css';
import { API_URL } from '../config';

const VehicleShowcase = () => {
  const [activeTab, setActiveTab] = useState('rental');
  const [vehicles, setVehicles] = useState({ rental: [], sale: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/vehicles`)
      .then(res => res.json())
      .then(data => {
        const rental = data.filter(v => v.type === 'Kiralık');
        const sale = data.filter(v => v.type === 'Satılık' || v.type === 'Satilik');
        setVehicles({ rental, sale });
        setLoading(false);
      })
      .catch(err => {
        console.error('Araçlar yüklenemedi:', err);
        setLoading(false);
      });
  }, []);

  const tabs = [
    { key: 'rental', label: 'Kiralık Araçlar' },
    { key: 'sale', label: 'Satılık Araçlar' },
  ];

  if (loading) return <div className="container" style={{ padding: '40px', color: 'var(--text-muted)' }}>Araçlar yükleniyor...</div>;

  return (
    <section id="vehicles" className="vs-section">
      <div className="container">
        {/* Header Row */}
        <div className="vs-header">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: [0.23, 1, 0.32, 1] }}
            viewport={{ once: true }}
          >
            <h2 className="section-title" style={{ marginBottom: 0 }}>
              Seçkin<span>Koleksiyon</span>
            </h2>
          </motion.div>

          {/* Tab Switcher */}
          <motion.div
            className="vs-tabs"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`vs-tab ${activeTab === tab.key ? 'vs-tab-active' : ''}`}
              >
                {activeTab === tab.key && (
                  <motion.div 
                    layoutId="activeVehicleTab"
                    className="vs-tab-bg"
                    transition={{ type: 'spring', bounce: 0, duration: 0.6 }}
                  />
                )}
                <span className="vs-tab-text">{tab.label}</span>
              </button>
            ))}
          </motion.div>
        </div>

        {/* Vehicle Count */}
        <div className="vs-count">
          <span className="vs-count-number">{vehicles[activeTab].length}</span>
          <span className="vs-count-label">araç listeleniyor</span>
        </div>

        {/* Cards Grid */}
        <motion.div layout className="vs-grid">
          <AnimatePresence mode="wait">
            {vehicles[activeTab].map((car) => (
              <VehicleCard 
                key={car.id} 
                {...car} 
                title={car.name || `${car.brand} ${car.model}`} 
                location={{ city: 'Kahramanmaraş' }} 
                specs={{ 
                  fuelType: car.fuel_type || '—', 
                  transmission: car.transmission || '—',
                  enginePower: car.engine_power ? (String(car.engine_power).toLowerCase().includes('hp') ? car.engine_power : `${car.engine_power} HP`) : '—'
                }} 
              />
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};

export default VehicleShowcase;
